import React, { useState, useEffect, useCallback, useContext } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, useManualQuery, ClientContext } from "graphql-hooks";
import {
  Container,
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  Typography,
  Divider,
  Radio,
  RadioGroup,
  Checkbox,
  Tooltip,
  Button,
  Dialog,
  DialogTitle,
  DialogActions,
  DialogContent,
  DialogContentText,
  FormControlLabel,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core";
import Box from "@mui/material/Box";
import Autocomplete from "@mui/material/Autocomplete";
import Collapse from "@mui/material/Collapse";
import List from "@mui/material/List";
import ListItemButton from "@mui/material/ListItemButton";
import IconButton from "@mui/material/IconButton";
import styled from "styled-components";
import { Link, useNavigate } from "react-router-dom";
import ShortTextIcon from "@mui/icons-material/ShortText";
import SubjectIcon from "@mui/icons-material/Subject";
import TocIcon from "@mui/icons-material/Toc";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import VisibilityIcon from "@mui/icons-material/Visibility";
import SwapVertOutlinedIcon from "@mui/icons-material/SwapVertOutlined";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { DndProvider } from "react-dnd";
import { HTML5Backend } from "react-dnd-html5-backend";
import draftToHtml from "draftjs-to-html";
import ReactHtmlParser from "react-html-parser";

import { FormComponents as Components } from "./FormComponents.js";
import { ComponentDragBox } from "./ComponentDragBox.js";
import { FormDropBox } from "./FormDropBox.js";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import Header from "./Header.js";
import AlertDialog from "../../components/AlertDialog.js";
import EditTextToFormDialog from "./components/EditTextToFormDialog.js";
import EditTextAreaToFormDialog from "./components/EditTextAreaToFormDialog.js";
import EditContentToFormDialog from "./components/EditContentToFormDialog.js";
import EditRadioButtonToFormDialog from "./components/EditRadioButtonToFormDialog.js";
import EditDropDownToFormDialog from "./components/EditDropDownToFormDialog.js";
import EditCheckboxToFormDialog from "./components/EditCheckboxToFormDialog.js";

import TextEditor from "./components/TextEditor.js";
import backImg from "../../assets/icons/back.png";
import penImg from "../../assets/icons/pen.png";
import arrowupImg from "../../assets/icons/arrow-up-right.png";
import dropdownImg from "../../assets/icons/dropdown.png";
import infoImg from "../../assets/icons/info.png";
import trashImg from "../../assets/icons/trash.png";

import { REFRESH_TOKEN_MUTATION, STAFF_MODULE_ACCESS_QUERY } from "../../graphQL/user_qry";
import {
  CREATE_RADIOBUTTON_MUTATION,
  EDIT_RADIOBUTTON_MUTATION,
} from "../../graphQL/radio_button__qry";
import {
  CREATE_TEXT_COMPONENT_MUTATION,
  EDIT_TEXT_COMPONENT_MUTATION,
} from "../../graphQL/text_qry";
import {
  CREATE_TEXTAREA_COMPONENT_MUTATION,
  EDIT_TEXTAREA_COMPONENT_MUTATION,
} from "../../graphQL/text_area_qry";
import {
  CREATE_DROPDOWN_MUTATION,
  EDIT_DROPDOWN_COMPONENT_MUTATION,
} from "../../graphQL/drop_down_qry";
import {
  CREATE_CHECKBOX_MUTATION,
  EDIT_CHECKBOX_MUTATION,
} from "../../graphQL/checkbox_qry";
import {
  CREATE_CONTENT_COMPONENT_MUTATION,
  EDIT_CONTENT_COMPONENT_MUTATION,
} from "../../graphQL/content_qry";
import {
  GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY,
  DELETE_COMPONENT_MUTATION,
} from "../../graphQL/component_qry";
import { SAVE_FORM_NAME_MUTATION } from "../../graphQL/form_qry";

import { project_url } from "../../constants/Data";

var findAnd = require("find-and");

const StyledTooltip = styled(props => (
  <Tooltip
    classes={{ popper: props.className }}
    {...props}
    PopperProps={{
      popperOptions: {
        modifiers: {
          flip: { enabled: false },
          offset: {
            offset: "0px, -50px, 20px, -25px",
          },
        },
      },
    }}
  />
))`
  & .MuiTooltip-tooltip {
    display: flex;
    background: #757575;
    color: #fff;
    border-radius: 4px;
    font-size: 10px;
    font-weight: 500;
  }
`;

const formLabelsTheme = createMuiTheme({
  overrides: {
    MuiFormLabel: {
      asterisk: {
        color: "#DB3131",
        "&$error": {
          color: "#DB3131",
        },
      },
    },
  },
});

const useStyles = makeStyles(theme => ({
  cardContainer: {
    marginRight: "8rem",
    textAlign: "center",
    padding: theme.spacing(2),
    paddingLeft: 0,
    paddingRight: 0,
    paddingTop: "7rem",
    minWidth: "1400px",
  },
  container: {
    marginTop: "1rem",
    marginBottom: "5rem",
    overflow: "hidden",
    clear: "both",
    // height: "936px",
    borderRadius: "8px",
  },

  ComponentDragBox: {
    float: "left",
  },
  FormDropBox: {
    float: "left",
    marginLeft: "5rem",
    marginTop: ".5rem",
  },
  outlinedButtonStyle: {
    borderRadius: 8,
    width: "110px",
    padding: 0,
    height: "48px",
    textTransform: "none",
  },
  buttonStyle: {
    borderRadius: 4,
    width: "100px",
    padding: 0,
    color: "#fff",
    height: "34px",
    backgroundColor: "#0D47A1",
    textTransform: "none",
    //  textTransform: "none",
    // "&:active": {
    //   backgroundColor: "#765285",
    // },
    "&:hover": {
      backgroundColor: "#1E88E5",
    },
  },
  dataGridStyle: {
    "& .MuiDataGrid-cell:focus-within": {
      outline: "none !important",
    },
    "& .MuiDataGrid-columnHeader:last-child .MuiDataGrid-columnSeparator": {
      display: "none",
    },
    "& .MuiDataGrid-columnHeaderTitle": {
      fontWeight: 700,
      fontSize: 12,
    },
  },
  textFieldStyle: {
    marginBottom: 5,
    width: 600,
    //marginTop: 20,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 8,
      fontSize: 16,
      backgroundColor: "#fff",
    },
  },
  formNameTextBoxStyle: {
    paddingTop: 12,
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    display: "flex",
    alignItems: "center",
  },

  objectBoxStyle: {
    margin: 15,
    borderRadius: "8px",
    border: "1px solid lightGray",
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  formNameTextStyle: {
    //minWidth: 200,
    cursor: "pointer",
    fontWeight: 500,
    borderRadius: "8px",
    height: 30,
    fontSize: 24,
    display: "flex",
    padding: 5,
    paddingRight: 10,
    alignItems: "center",
    lineHeight: 1,
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  backStyle: {
    cursor: "pointer",
    borderRadius: "4px",
    height: 35,
    display: "flex",
    alignItems: "center",
    "&:hover": {
      backgroundColor: "#F5F5F5",
    },
  },
  iconStyle: {
    marginLeft: 12,
    height: 18,
    padding: 10,
    display: "flex",
    alignItems: "center",
    border: "1px solid lightGray",
    borderRadius: "4px",
    cursor: "pointer",
    "&:hover": {
      backgroundColor: "#EEEEEE",
    },
  },
  formNameFieldStyle: {
    width: 600,
    //marginTop: 20,
    "& .MuiInputLabel-outlined": {
      fontSize: 16,
    },
    "& .MuiOutlinedInput-root": {
      borderRadius: 4,
      height: 40,
      fontSize: 16,
      backgroundColor: "#fff",
    },
  },
  dragIconBoxStyle: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    paddingTop: 15,
    paddingBottom: 15,
    paddingLeft: 12,
    paddingRight: 2,
    marginTop: 5,
    marginLeft: 5,
    marginRight: 5,
    borderRadius: 4,
    "&:hover": {
      backgroundColor: "#E2F2FF",
    },
  },
  selectStyle: {
    maxWidth: 364,
    textAlign: "left",
  },
  radioLabelStyle: {
    "& .MuiTypography-body1": {
      fontSize: 16,
    },
  },
}));

function FormDialog() {
  const [loadContent, setLoadContent] = useState(false);
  const client = useContext(ClientContext);
  const navigate = useNavigate();
  const [pathname] = useState(window.location.pathname);
  const [refreshToken] = useMutation(REFRESH_TOKEN_MUTATION, {
    onError: err => {
      console.log(err);
    },
  });
  useEffect(() => {
    if (localStorage.getItem("refreshToken")) {
      onRefreshToken();
    } else {
      window.location.href = `${project_url}/signin/?next=${pathname}`;
    }
  }, []);
  const onRefreshToken = async () => {
    const { data: refreshData, error: refreshError } = await refreshToken({
      variables: { refreshToken: localStorage.getItem("refreshToken") },
    });
    if (refreshError) {
      if (
        refreshError.graphQLErrors[0].message ===
        "You do not have permission to perform this action"
      )
        navigate(`${project_url}/signin/?next=${pathname}`);
      if (refreshError.graphQLErrors[0].message === "Signature has expired")
        navigate(`${project_url}/signin/?next=${pathname}`);
    }
    if (refreshData && refreshData.refreshToken) {
      localStorage.setItem("token", refreshData.refreshToken.token);
      localStorage.setItem("refreshToken", refreshData.refreshToken.refreshToken);
      client.setHeader("Authorization", `JWT ${refreshData.refreshToken.token}`);
      setLoadContent(true);
    }
  };
  const { formUuid } = useParams();
  const classes = useStyles();
  const [mutiOptFields, setMutiOptFields] = useState([]);
  const [alertMsg, setAlertMsg] = useState([]);
  const [previewAlertMsg, setPreviewAlertMsg] = useState([]);
  const [infoIcon, setInfoIcon] = useState(false);
  const [manAnswer, setManAnswer] = useState(false);
  const [queText, setQueText] = useState(false);
  const [queRaw, setQueRaw] = useState(false);
  const [capText, setCapText] = useState(false);
  const [capRaw, setCapRaw] = useState(false);
  const [maxChar, setMaxChar] = useState("");
  const [infoTxt, setInfoTxt] = useState("");
  const [selectedVal, setSelectedVal] = useState("Select");
  const [selectedOpts, setSelectedOpts] = useState([]);
  const [width, setWidth] = useState("");
  const [height, setHeight] = useState("");
  const [addEditStatus, setAddEditStatus] = useState(null);
  const [formName, setFormName] = useState();
  const [formId, setFormId] = useState();
  const [editedFormName, setEditedFormName] = useState();
  const [editingFormName, setEditingFormName] = useState(false);
  const [lastDroppedComponent, setLastDroppedComponent] = useState(null);
  const [focusFormName, setFocusFormName] = useState(false);
  const [open, setOpen] = useState({});
  const [objectType, setObjectType] = useState(null);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [allComponents, setAllComponents] = useState([]);
  const [currentEditComponent, setCurrentEditComponent] = useState(null);
  const [currentEditCompIndx, setCurrentEditCompIndx] = useState(null);
  const [addedComponentIndx, setAddedComponentIndx] = useState(null);
  const [deleteComponent, setDeleteComponent] = useState(null);

  const [createRadioButton] = useMutation(CREATE_RADIOBUTTON_MUTATION);
  const [createTextComponent] = useMutation(CREATE_TEXT_COMPONENT_MUTATION);
  const [createTextAreaComponent] = useMutation(CREATE_TEXTAREA_COMPONENT_MUTATION);
  const [createDropDownComponent] = useMutation(CREATE_DROPDOWN_MUTATION);
  const [createCheckboxComponent] = useMutation(CREATE_CHECKBOX_MUTATION);
  const [createContentComponent] = useMutation(CREATE_CONTENT_COMPONENT_MUTATION);

  const [editContentComponent] = useMutation(EDIT_CONTENT_COMPONENT_MUTATION);
  const [editTextComponent] = useMutation(EDIT_TEXT_COMPONENT_MUTATION);
  const [editTextAreaComponent] = useMutation(EDIT_TEXTAREA_COMPONENT_MUTATION);
  const [editDropDownComponent] = useMutation(EDIT_DROPDOWN_COMPONENT_MUTATION);
  const [editRadioButtonComponent] = useMutation(EDIT_RADIOBUTTON_MUTATION);
  const [editCheckBoxComponent] = useMutation(EDIT_CHECKBOX_MUTATION);


  const [editAccess, setEditAccess] = useState(true);


  const [delComponent] = useMutation(DELETE_COMPONENT_MUTATION);

  const [fetchFormComponentsAnswers] = useManualQuery(
    GET_COMPONENTS_ANSWERS_BY_FORM_ID_QUERY,
    {
      fetchPolicy: "network-only",
    }
  );

  let tenantUserId = 0;
  if(localStorage.getItem("tenantUserId"))
    tenantUserId = localStorage.getItem("tenantUserId");

  let isTenantAdmin = false;
  if(localStorage.getItem("isTenantAdmin"))
    isTenantAdmin = JSON.parse(localStorage.getItem("isTenantAdmin"));

  let clientId = 0;
  if (localStorage.getItem("clientId"))
    clientId = localStorage.getItem("clientId");

  const [saveFormName] = useMutation(SAVE_FORM_NAME_MUTATION, {
    awaitRefetchQueries: true,
  });

  const [checkStaffModuleAccess] = useManualQuery(STAFF_MODULE_ACCESS_QUERY, {
    fetchPolicy: "network-only",
  });

  const checkAccess = async () => {
    //check if staff has access to module

    const {
            loading: accessDataLoading,
            error: accessDataError,
            data: accessData,
          } = await checkStaffModuleAccess({
            variables: {
              tenantUserId: parseInt(tenantUserId),
              clientId: parseInt(clientId),
              moduleName: "Forms",
              modulepageName: "List"
            },
          });

    if (!accessDataLoading && accessData && accessData.staffModuleAccess) {


      let commonActions = accessData.staffModuleAccess.commonActions.split('|');


      if(commonActions.find(a => a == "Edit")){
        setEditAccess(true);}
      else {setEditAccess(false)}



    }

    if (  accessDataError &&
          accessDataError.graphQLErrors &&
          accessDataError.graphQLErrors[0].message === "Signature has expired"
       ) {
            navigate(`${project_url}/signin`);
          }
  }

   useEffect(() => {
    window.scrollTo(0, 0);
    (() => checkAccess())();
  }, []);


  const getFormComponents = async (addedComponentId = null) => {
    let resFound = {};
    if (formUuid) {
      const {
        loading: formComponentsAnswersLoading,
        error: formComponentsAnswersError,
        data: formComponentsAnswersData,
      } = await fetchFormComponentsAnswers({
        variables: { formUuid: formUuid },
      });

      if (formComponentsAnswersData.formComponentAnswerList == null)
      {
        navigate(`${project_url}/tenant/dashboard`)
      }

      else if (
        !formComponentsAnswersLoading &&
        formComponentsAnswersData &&
        formComponentsAnswersData.formComponentAnswerList
      ) {
        console.log(
          "allComponents----",
          formComponentsAnswersData.formComponentAnswerList.componentList
        );

        setAllComponents(formComponentsAnswersData.formComponentAnswerList.componentList);
        // Set the index of added component for expand and collapse
        if (addedComponentId) {
          resFound = formComponentsAnswersData.formComponentAnswerList.componentList.find(
            item => {
              return item.componentId === addedComponentId;
            }
          );
          if (resFound) {
            setAddedComponentIndx(
              formComponentsAnswersData.formComponentAnswerList.componentList.indexOf(
                resFound
              )
            );
          }
        }
        //
        setFormId(formComponentsAnswersData.formComponentAnswerList.formId);
        setFormName(formComponentsAnswersData.formComponentAnswerList.name);
        setEditedFormName(formComponentsAnswersData.formComponentAnswerList.name);
      }
      if (
        formComponentsAnswersError &&
        formComponentsAnswersError.graphQLErrors[0].message === "Signature has expired"
      ) {
        navigate(`${project_url}/signin`);
      }
    }
  };

  useEffect(() => {
    // Seting expand/collapse flag for each component
    if (addEditStatus && lastDroppedComponent === null) {
      // After Saving a new object all the objects will be collapsed on form
      let openList = Object.fromEntries(
        Array.from({ length: allComponents.length }, (_, i) => [i, false])
      );
      if (currentEditCompIndx !== null) {
        openList[currentEditCompIndx] = true;
      } else if (addedComponentIndx !== null) {
        openList[addedComponentIndx] = true;
      }
      setOpen(openList);
    }
  }, [allComponents, addedComponentIndx, currentEditCompIndx]);

  useEffect(() => {
    (() => getFormComponents())();
    window.scrollTo(0, 0);
  }, [formUuid]);

  const handleDrop = useCallback(component => setLastDroppedComponent(component), null);
  const handleDoneAddEditObjectToForm = (
    object,
    addEditStatus,
    infoIcon,
    manAnswer,
    queText,
    queRaw,
    capText,
    capRaw,
    maxChar = null,
    infoTxt,
    selectedVal = null,
    selectedOpts = null,
    mutiOptFields = null,
    width = null,
    height = null,
    editMode = false
  ) => {
    setLastDroppedComponent(null);
    setObjectType(object);
    setOpenEditDialog(false);
    setAddEditStatus(addEditStatus);
    setInfoIcon(infoIcon);
    setManAnswer(manAnswer);
    setQueText(queText);
    setQueRaw(queRaw);
    setCapText(capText);
    setCapRaw(capRaw);
    setMaxChar(maxChar);
    setInfoTxt(infoTxt);
    setSelectedVal(selectedVal);
    setSelectedOpts(selectedOpts);
    setMutiOptFields(mutiOptFields);
    setWidth(width);
    setHeight(height);

    // Save each object based on object type
    if (object == "Radio Button") {
      saveRadioButton(queRaw, capRaw, manAnswer, infoTxt, selectedOpts, editMode);
    } else if (object == "Text") {
      saveTextComponent(infoTxt, manAnswer, queRaw, capRaw, maxChar, editMode);
    } else if (object == "Content") {
      saveContentComponent(queRaw, capRaw, editMode);
    } else if (object == "Text Area") {
      saveTextAreaComponent(
        infoTxt,
        manAnswer,
        queRaw,
        capRaw,
        maxChar,
        editMode,
        width,
        height
      );
    } else if (object == "Drop Down") {
      saveDropDownComponent(queRaw, capRaw, manAnswer, infoTxt, selectedOpts, editMode);
    } else if (object == "Checkbox") {
      saveCheckboxComponent(queRaw, capRaw, manAnswer, infoTxt, mutiOptFields, editMode);
    }
  };

  const saveContentComponent = async (queRaw, capRaw, editMode) => {
    if (formId) {
      if (!editMode) {
        // In save mode ( Save new entered object)
        const { data, error } = await createContentComponent({
          variables: {
            label: JSON.stringify(queRaw),
            caption: JSON.stringify(capRaw),
            formId: parseInt(formId),
          },
        });

        if (error) {
          console.log("Error", error, data);
          //  setTimeout("");
        } else if (data && data.createContentComponent) {
          console.log("Success Saving Content Component");
          getFormComponents(data.createContentComponent.component.componentId);
          // alert("New Content added successfully to " + formName);
        }
        setCurrentEditCompIndx(null);
      } else {
        //In edit mode ( Edit an existing object)
        const { data, error } = await editContentComponent({
          variables: {
            componentId: parseInt(currentEditComponent.componentId),
            label: JSON.stringify(queRaw),
            caption: JSON.stringify(capRaw),
          },
        });

        if (error) {
          console.log("Error", error, data);
          //  setTimeout("");
        } else if (data && data.editContent) {
          console.log("Success Editing Content Component");
          getFormComponents(data.editContent.component.componentId);
        }
      }
    } else {
      alert("Are you sure you have valid URL?");
    }
  };

  const saveTextComponent = async (
    infoTxt,
    manAnswer,
    queRaw,
    capRaw,
    maxChar,
    editMode
  ) => {
    if (!maxChar) maxChar = 100;

    if (formId) {
      if (!editMode) {
        // In save mode ( Save new entered object)
        const { data, error } = await createTextComponent({
          variables: {
            tooltip: infoTxt,
            mandatory: manAnswer,
            label: JSON.stringify(queRaw),
            caption: JSON.stringify(capRaw),
            maxLength: parseInt(maxChar),
            formId: parseInt(formId),
          },
        });

        if (error) {
          console.log("Error", error, data);
          //  setTimeout("");
        } else if (data && data.createTextComponent) {
          console.log("Success Saving Text Component");
          getFormComponents(data.createTextComponent.answer.componentId.componentId);
          // alert("New Text Question added successfully to " + formName);
        }
        setCurrentEditCompIndx(null);
      } else {
        //In edit mode ( Edit an existing object)
        const { data, error } = await editTextComponent({
          variables: {
            componentId: parseInt(currentEditComponent.componentId),
            label: JSON.stringify(queRaw),
            caption: JSON.stringify(capRaw),
            maxLength: parseInt(maxChar),
            tooltip: infoTxt,
            mandatory: manAnswer,
          },
        });

        if (error) {
          console.log("Error", error, data);
          //  setTimeout("");
        } else if (data && data.editText) {
          console.log("Success Editing Text Component");
          getFormComponents(data.editText.component.componentId);
        }
      }
    } else {
      alert("Are you sure you have valid URL?");
    }
  };

  const saveTextAreaComponent = async (
    infoTxt,
    manAnswer,
    queRaw,
    capRaw,
    maxChar,
    editMode,
    width,
    height
  ) => {
    if (!maxChar) maxChar = 100;

    if (formId) {
      if (!editMode) {
        // In save mode ( Save new entered object)
        const { data, error } = await createTextAreaComponent({
          variables: {
            tooltip: infoTxt,
            mandatory: manAnswer,
            label: JSON.stringify(queRaw),
            caption: JSON.stringify(capRaw),
            maxLength: parseInt(maxChar),
            formId: parseInt(formId),
            width: parseInt(width),
            height: parseInt(height),
          },
        });

        if (error) {
          console.log("Error", error, data);
          //  setTimeout("");
        } else if (data && data.createTextareaComponent) {
          console.log("Success Saving Text Area Component");
          getFormComponents(data.createTextareaComponent.answer.componentId.componentId);
          // alert("New Text Area Question added successfully to " + formName);
        }
        setCurrentEditCompIndx(null);
      } else {
        //In edit mode ( Edit an existing object)
        const { data, error } = await editTextAreaComponent({
          variables: {
            componentId: parseInt(currentEditComponent.componentId),
            label: JSON.stringify(queRaw),
            caption: JSON.stringify(capRaw),
            maxLength: parseInt(maxChar),
            tooltip: infoTxt,
            mandatory: manAnswer,
            width: parseInt(width),
            height: parseInt(height),
          },
        });

        if (error) {
          console.log("Error", error, data);
          //  setTimeout("");
        } else if (data && data.editTextarea) {
          console.log("Success Editing Text Area Component");
          getFormComponents(data.editTextarea.component.componentId);
        }
      }
    } else {
      alert("Are you sure you have valid URL?");
    }
  };

  const saveRadioButton = async (
    queRaw,
    capRaw,
    manAnswer,
    infoTxt,
    selectedOpts,
    editMode
  ) => {
    if (formId) {
      const options = selectedOpts.map(({ title }) => title);

      if (!editMode) {
        // In save mode ( Save new entered object)
        const { data, error } = await createRadioButton({
          variables: {
            formId: parseInt(formId),
            infoTxt: infoTxt,
            manAnswer: manAnswer,
            queText: JSON.stringify(queRaw),
            capText: JSON.stringify(capRaw),

            options,
          },
        });

        if (error) {
          console.log("Error", error, data);
          //  setTimeout("");
        } else if (data && data.createRadiobutton) {
          console.log("Success Saving Radio Button Component");
          getFormComponents(data.createRadiobutton.component.componentId);
          // alert(
          //   "New Radio Button Question was successfully added to '" + formName + "' form."
          // );
        }
        setCurrentEditCompIndx(null);
      } else {
        //In edit mode ( Edit an existing component)
        const { data, error } = await editRadioButtonComponent({
          variables: {
            componentId: parseInt(currentEditComponent.componentId),
            tooltip: infoTxt,
            mandatory: manAnswer,
            label: JSON.stringify(queRaw),
            caption: JSON.stringify(capRaw),

            options: options,
          },
        });

        if (error) {
          console.log("Error", error, data);
          //  setTimeout("");
        } else if (data && data.editRadiobutton) {
          console.log("Success Editing Radio Button Component");
          getFormComponents(data.editRadiobutton.component.componentId);
        }
      }
    } else {
      alert("Are you sure you have valid URL?");
    }
  };

  const saveDropDownComponent = async (
    queRaw,
    capRaw,
    manAnswer,
    infoTxt,
    selectedOpts,
    editMode
  ) => {
    if (formId) {
      const options = selectedOpts.map(({ title }) => title);

      if (!editMode) {
        // In save mode ( Save new entered object)
        const { data, error } = await createDropDownComponent({
          variables: {
            formId: parseInt(formId),
            tooltip: infoTxt,
            mandatory: manAnswer,
            label: JSON.stringify(queRaw),
            caption: JSON.stringify(capRaw),

            options: options,
          },
        });

        if (error) {
          console.log("Error", error, data);
          //  setTimeout("");
        } else if (data && data.createDropdown) {
          console.log("Success Saving Drop Down Component");
          getFormComponents(data.createDropdown.component.componentId);
          // alert(
          //   "New Drop Down Question was successfully added to '" + formName + "' form."
          // );
        }
        setCurrentEditCompIndx(null);
      } else {
        //In edit mode ( Edit an existing component)
        const { data, error } = await editDropDownComponent({
          variables: {
            componentId: parseInt(currentEditComponent.componentId),
            tooltip: infoTxt,
            mandatory: manAnswer,
            label: JSON.stringify(queRaw),
            caption: JSON.stringify(capRaw),

            options: options,
          },
        });

        if (error) {
          console.log("Error", error, data);
          //  setTimeout("");
        } else if (data && data.editDropdown) {
          console.log("Success Editing Drop Down Component");
          getFormComponents(data.editDropdown.component.componentId);
        }
      }
    } else {
      alert("Are you sure you have valid URL?");
    }
  };

  const saveCheckboxComponent = async (
    queRaw,
    capRaw,
    manAnswer,
    infoTxt,
    mutiOptFields,
    editMode
  ) => {
    if (formId) {
      let options = [];
      if (mutiOptFields.length > 0) options = mutiOptFields.map(({ textVal }) => textVal);

      if (!editMode) {
        const { data, error } = await createCheckboxComponent({
          variables: {
            formId: parseInt(formId),
            tooltip: infoTxt,
            mandatory: manAnswer,
            label: JSON.stringify(queRaw),
            caption: JSON.stringify(capRaw),

            options: options,
          },
        });

        if (error) {
          console.log("Error", error, data);
          //  setTimeout("");
        } else if (data && data.createCheckbox) {
          console.log("Success Saving Checkbox Component");
          getFormComponents(data.createCheckbox.component.componentId);
          // alert("New Checkbox Question was successfully added to '" + formName + "' form.");
        }
        setCurrentEditCompIndx(null);
      } else {
        //In edit mode ( Edit an existing component)
        const { data, error } = await editCheckBoxComponent({
          variables: {
            componentId: parseInt(currentEditComponent.componentId),
            tooltip: infoTxt,
            mandatory: manAnswer,
            label: JSON.stringify(queRaw),
            caption: JSON.stringify(capRaw),

            options: options,
          },
        });

        if (error) {
          console.log("Error", error, data);
          //  setTimeout("");
        } else if (data && data.editCheckbox) {
          console.log("Success Editing Check Box Component");
          getFormComponents(data.editCheckbox.component.componentId);
        }
      }
    } else {
      alert("Are you sure you have valid URL?");
    }
  };

  const handleEditFormName = async () => {
    if (editedFormName.trim() != "") {
      setFormName(editedFormName);
      setEditingFormName(false);
      const { data, error } = await saveFormName({
        variables: {
          name: editedFormName,
          formId: parseInt(formId),
        },
      });
      if (error) {
        console.log("Error", error, data);
        alert("Unfortunately an error occurred.");
      } else if (data && data.saveFormName) {
        console.log("Success", data);
        //navigate(`${project_url}/forms/${data.createForm.form.formUuid}`);
      }
    } else alert("Please specify a name for your form.");
  };

  const toggleEditDialog = (component, indx) => {
    setCurrentEditComponent(component);
    setCurrentEditCompIndx(indx);
    setOpenEditDialog(!openEditDialog);
  };

  const removeComponent = async () => {
    setAddEditStatus(null);
    const { data, error } = await delComponent({
      variables: {
        componentId: parseInt(deleteComponent.componentId),
      },
    });

    if (error) {
      console.log("Error", error, data);
    } else if (data && data.deleteComponent) {
      console.log("Success Deleting Component");
      getFormComponents();
    }
  };

  const convertTxtToRichTxt = txt => {

    //let contentHTML = draftToHtml(JSON.parse(txt.replace(/'/g, '"')));
    //Commented by Sami
    let contentHTML = draftToHtml(JSON.parse(txt));
    contentHTML = contentHTML.replace(/<p>/, "");

    contentHTML = contentHTML.replace(
      /<a[^>]*href="([^"]+)"[^>]*>(.*?)<\/a>/gi,
      (match, href, text) => {
        // Remove leading protocols
        href = href.replace(/^(https?:\/\/)+/, "");

        // Prepend https://
        href = `https://${href}`;

        return `<a href="${href}" target="_blank">${text}</a>`;
      }
    );
    const convertedTxt = ReactHtmlParser(contentHTML);
    return convertedTxt;
  };

  const handleExpandClick = index => {
    setOpen({
      ...open,
      [index]: !open[index],
    });
  };

  if (loadContent)
    if (editAccess)
    return (
      <div className={classes.cardContainer}>
        <Header breadcrumbs={[{ label: formName, link: null }]} />
        <div className={classes.container}>
          <DndProvider backend={HTML5Backend}>
            <Grid container spacing={1}>
              <Grid item style={{ width: 180 }}>
                <Card style={{ height: 450 }}>
                  <Box mb={1}>
                    <Box
                      mt={2}
                      mb={1}
                      ml={1}
                      style={{
                        display: "flex",
                        flexDirection: "row",
                        justifyContent: "start",
                        alignItems: "center",
                      }}
                    >
                      <IconButton>
                        <img
                          src={backImg}
                          height={24}
                          onClick={() => navigate(`${project_url}/forms`)}
                        />
                      </IconButton>
                      <Typography
                        variant="h5"
                        className={classes.backStyle}
                        onClick={() => navigate(`${project_url}/forms`)}
                      >
                        Back
                      </Typography>
                    </Box>
                    <Divider />
                    <Box className={classes.dragIconBoxStyle}>
                      <ComponentDragBox
                        component={Components.TEXT_FIELD}
                        text="Text"
                        icon="ShortTextIcon"
                      />
                    </Box>
                    <Box className={classes.dragIconBoxStyle}>
                      <ComponentDragBox
                        component={Components.TEXT_AREA_FIELD}
                        text="Text Area"
                        icon="SubjectIcon"
                      />
                    </Box>
                    <Box className={classes.dragIconBoxStyle}>
                      <ComponentDragBox
                        component={Components.CONTENT_FIELD}
                        text="Content"
                        icon="TocIcon"
                      />
                    </Box>
                    <Box className={classes.dragIconBoxStyle}>
                      <ComponentDragBox
                        component={Components.DROP_DOWN_FIELD}
                        text="Drop Down"
                        icon="DropDownIcon"
                      />
                    </Box>
                    <Box className={classes.dragIconBoxStyle}>
                      <ComponentDragBox
                        component={Components.RADIO_BUTTON}
                        text="Radio Button"
                        icon="RadioButtonCheckedIcon"
                      />
                    </Box>
                    <Box className={classes.dragIconBoxStyle}>
                      <ComponentDragBox
                        component={Components.CHECKBOX_FIELD}
                        text="Checkbox"
                        icon="CheckBoxIcon"
                      />
                    </Box>
                  </Box>
                </Card>
              </Grid>
              <Grid item lg md xl xs style={{ width: 1220 }}>
                <Card style={{ minHeight: 450 }}>
                  <Box
                    //  mt={1.5}
                    mb={1.5}
                    ml={3}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "space-between",
                    }}
                  >
                    {!editingFormName ? (
                      <Box className={classes.formNameTextBoxStyle}>
                        <Typography
                          variant="h1"
                          className={classes.formNameTextStyle}
                          onClick={() => {
                            setEditingFormName(true);
                            setFocusFormName(true);
                          }}
                        >
                          {formName}
                        </Typography>
                        <IconButton>
                        <EditOutlinedIcon
                        onClick={() => {
                          setEditingFormName(true);
                          setFocusFormName(true);
                        }}
                        />
                        </IconButton>
                      </Box>
                    ) : (
                      <Box
                        style={{
                          paddingTop: 12,
                          display: "flex",
                          flexDirection: "row",
                          justifyContent: "start",
                          width: 400,
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <TextField
                          id="outlined-multiline-static"
                          variant="outlined"
                          value={editedFormName}
                          inputRef={input => {
                            if (focusFormName && input != null) {
                              input.focus();
                            }
                          }}
                          className={classes.formNameFieldStyle}
                          onChange={e => {
                            setEditedFormName(e.target.value);
                          }}
                          onKeyDown={e => {
                            e.key === "Enter" && handleEditFormName();
                          }}
                        />

                        <Box className={classes.iconStyle} onClick={handleEditFormName}>
                          <CheckIcon sx={{ color: "gray", cursor: "pointer" }} />
                        </Box>

                        <Box
                          className={classes.iconStyle}
                          style={{ marginLeft: 7 }}
                          onClick={() => {
                            setEditingFormName(false);
                            setEditedFormName(formName);
                          }}
                        >
                          <CloseIcon sx={{ color: "gray", cursor: "pointer" }} />
                        </Box>
                      </Box>
                    )}
                    <Box mr={3} mt={1.5}>
                      <StyledTooltip title="Reorder Objects">
                        <IconButton>
                          <SwapVertOutlinedIcon
                            onClick={() =>
                              navigate(`${project_url}/forms/` + formUuid + "/reorder-objects")
                            }
                          />
                        </IconButton>
                      </StyledTooltip>

                      <StyledTooltip title="Preview Form">
                        <IconButton>

                            <VisibilityIcon onClick={() =>
                                    allComponents.length !== 0
                                      ? window.open(`${project_url}/forms/` + formUuid + "/preview-edit")
                                      : setPreviewAlertMsg({
                                          title: "Preview Form",
                                          msg: "This form has no object. Nothing to preview.",
                            }) } />


                        </IconButton>
                      </StyledTooltip>
                    </Box>
                  </Box>

                  <Divider />
                  <Box mt={3} ml={2} mr={2}>
                    <FormDropBox
                      lastDroppedComponent={lastDroppedComponent}
                      onDrop={handleDrop}
                      passComOptions={(
                        object,
                        addEditStatus,
                        infoIcon,
                        manAnswer,
                        queText,
                        queRaw,
                        capText,
                        capRaw,
                        maxChar,
                        infoTxt,
                        selectedVal,
                        selectedOpts,
                        mutiOptFields,
                        width,
                        height
                      ) =>
                        handleDoneAddEditObjectToForm(
                          object,
                          addEditStatus,
                          infoIcon,
                          manAnswer,
                          queText,
                          queRaw,
                          capText,
                          capRaw,
                          maxChar,
                          infoTxt,
                          selectedVal,
                          selectedOpts,
                          mutiOptFields,
                          width,
                          height
                        )
                      }
                      closeAddDialog={() => setLastDroppedComponent(null)}
                    />
                    <TextEditor />
                  </Box>
                  <Box
                    mt={1}
                    style={{
                      display: "flex",
                      flexDirection: "row",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      variant="h5"
                      style={{
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      Drag and drop your object into this box.
                    </Typography>
                    <img
                      style={{
                        paddingLeft: 5,
                        paddingBottom: 5,
                        height: 24,
                      }}
                      src={arrowupImg}
                    />
                  </Box>
                  {allComponents.map((component, index) => (
                    <Box
                      className={classes.objectBoxStyle}
                      style={{
                        backgroundColor: open[index] ? "#E2F2FF" : "",
                      }}
                    >
                      <List
                        sx={{
                          paddingTop: 0,
                          paddingBottom: 0,
                          "& .MuiListItemButton-root:hover": {
                            backgroundColor: "transparent",
                          },
                        }}
                      >
                        <ListItemButton
                          disableRipple
                          style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            paddingLeft: 10,
                            paddingTop: 5,
                            paddingBottom: 0,
                            cursor: "default",
                          }}
                          // onClick={() => toggleEditDialog(component, index)}
                        >
                          <Box
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              paddingTop: 10,
                            }}
                          >
                            {component && component.answerTypeId.name === "text" && (
                              <StyledTooltip title="Object: Text">
                                <ShortTextIcon
                                  style={{
                                    marginRight: 10,
                                    color: "#fff",
                                    backgroundColor: "#0057B2",
                                    borderRadius: 4,
                                  }}
                                />
                              </StyledTooltip>
                            )}
                            {component && component.answerTypeId.name === "textarea" && (
                              <StyledTooltip title="Object: Text Area">
                                <SubjectIcon
                                  style={{
                                    marginRight: 10,
                                    color: "#fff",
                                    backgroundColor: "#0057B2",
                                    borderRadius: 4,
                                  }}
                                />
                              </StyledTooltip>
                            )}
                            {component &&
                              component.componentTypeId.name === "decorative" && (
                                <StyledTooltip title="Object: Content">
                                  <TocIcon
                                    style={{
                                      marginRight: 10,
                                      color: "#fff",
                                      backgroundColor: "#0057B2",
                                      borderRadius: 4,
                                    }}
                                  />
                                </StyledTooltip>
                              )}
                            {component &&
                              (component.answerTypeId.name === "drop_down" ||
                                component.answerTypeId.name === "drop_down_state" ||
                                component.answerTypeId.name === "drop_down_country") && (
                                <StyledTooltip title="Object: Drop Down">
                                  <img
                                    style={{
                                      marginRight: 10,
                                      borderRadius: 4,
                                      height: 24,
                                    }}
                                    src={dropdownImg}
                                  />
                                </StyledTooltip>
                              )}
                            {component &&
                              component.answerTypeId.name === "radio_button" && (
                                <StyledTooltip title="Object: Radio Button">
                                  <RadioButtonCheckedIcon
                                    style={{
                                      marginRight: 10,
                                      color: "#fff",
                                      backgroundColor: "#0057B2",
                                      borderRadius: 4,
                                    }}
                                  />
                                </StyledTooltip>
                              )}

                            {component &&
                              (component.answerTypeId.name === "checkbox_single" ||
                                component.answerTypeId.name === "checkbox_multiple") && (
                                <StyledTooltip
                                  title={
                                    component.answerTypeId.name === "checkbox_single"
                                      ? "Object: Single Checkbox"
                                      : "Object: Multiple Checkboxes"
                                  }
                                >
                                  <CheckBoxIcon
                                    style={{
                                      marginRight: 10,
                                      color: "#fff",
                                      backgroundColor: "#0057B2",
                                      borderRadius: 4,
                                      marginTop:
                                        component.answerTypeId.name ===
                                          "checkbox_single" && 8,
                                    }}
                                  />
                                </StyledTooltip>
                              )}

                            <Box
                              style={{
                                display: "flex",
                                flexDirection: "row",
                              }}
                            >
                              {component &&
                              component.tooltip !== "" &&
                              component.answerTypeId.name !== "content" ? (
                                <StyledTooltip title={component.tooltip}>
                                  <img
                                    style={{
                                      paddingBottom: 3,
                                      height: 24,
                                      paddingTop:
                                        component.answerTypeId.name ===
                                          "checkbox_single" && 8,
                                    }}
                                    src={infoImg}
                                  />
                                </StyledTooltip>
                              ) : (
                                ""
                              )}
                            </Box>
                            <Typography variant="h3">
                              <div
                                style={{
                                  wordBreak: "break-word",
                                  paddingLeft: 5,
                                }}
                              >
                                {component &&
                                  component.answerTypeId.name === "checkbox_single" &&
                                  component.answerList.length == 1 &&
                                  component.mandatory && (
                                    <>
                                      <span
                                        style={{
                                          color: "#E53935",
                                          verticalAlign: "sub",
                                        }}
                                      >
                                        {" "}
                                        *
                                      </span>
                                      <Checkbox />
                                    </>
                                  )}
                                {component &&
                                  component.answerTypeId.name === "checkbox_single" &&
                                  component.answerList.length == 1 &&
                                  !component.mandatory && <Checkbox />}

                                {component.label
                                  ? convertTxtToRichTxt(component.label)
                                  : ""}
                              </div>
                            </Typography>
                          </Box>

                          <Box pl={1} style={{ display: "flex", alignItems: "center" }}>
                            <StyledTooltip title="Edit this object">
                              <IconButton style={{ paddingRight: 6 }}>
                                <img
                                  src={penImg}
                                  onClick={() => toggleEditDialog(component, index)}
                                />
                              </IconButton>
                            </StyledTooltip>

                            <StyledTooltip title="Delete this object">
                              <IconButton style={{ paddingRight: 6 }}>
                                <img
                                  src={trashImg}
                                  height={24}
                                  onClick={e => {
                                    e.stopPropagation();
                                    setDeleteComponent(component);
                                    setAlertMsg({
                                      title: "Delete Object",
                                      type: "deleteConfirmation",
                                      msg: "Are you sure you want to delete this object?",
                                    });
                                  }}
                                />
                              </IconButton>
                            </StyledTooltip>
                            <IconButton
                              onClick={e => {
                                handleExpandClick(index);
                                e.stopPropagation();
                              }}
                              aria-label="expand"
                              size="small"
                            >
                              {open[index] ? (
                                <StyledTooltip title="Collapse this object">
                                  <KeyboardArrowUpIcon />
                                </StyledTooltip>
                              ) : (
                                <StyledTooltip title="Expand this object">
                                  <KeyboardArrowDownIcon />
                                </StyledTooltip>
                              )}
                            </IconButton>
                          </Box>
                        </ListItemButton>

                        <Collapse in={open[index]} timeout="auto" unmountOnExit>
                          <CardContent
                            style={{
                              paddingTop: 20,
                              display: "flex",
                              flexDirection: "column",
                              justifyContent: "flex-start",
                              marginLeft: 30,
                            }}
                          >
                            {component && component.caption && (
                              <Typography
                                variant="h3"
                                style={{
                                  fontSize: 14,
                                  display: "flex",
                                  alignItems: "center",
                                  paddingBottom: 10,
                                }}
                              >
                                <div
                                  style={{
                                    textAlign: "left",
                                    wordBreak: "break-word",
                                    paddingLeft: 5,
                                  }}
                                >
                                  {convertTxtToRichTxt(component.caption)}
                                </div>
                              </Typography>
                            )}
                            {component &&
                              (component.answerTypeId.name === "text" ||
                                component.answerTypeId.name === "textarea") && (
                                <>
                                  <Box
                                    pb={0.25}
                                    style={{
                                      display: "flex",
                                      flexDirection: "row",
                                    }}
                                  >
                                    <Typography
                                      variant="h3"
                                      style={{
                                        fontSize: 14,
                                        display: "flex",
                                        alignItems: "center",
                                        paddingLeft: 5,
                                      }}
                                    >
                                      Answer
                                    </Typography>
                                    {component.mandatory && (
                                      <StyledTooltip title="required field">
                                        <Typography
                                          variant="h3"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            color: "#E53935",
                                            paddingLeft: 5,
                                            paddingRight: 5,
                                          }}
                                        >
                                          *
                                        </Typography>
                                      </StyledTooltip>
                                    )}
                                  </Box>

                                  <TextField
                                    id="outlined-multiline-static"
                                    variant="outlined"
                                    className={classes.textFieldStyle}
                                  />
                                  <Typography
                                    variant="h6"
                                    style={{
                                      display: "flex",
                                      alignItems: "center",
                                      paddingRight: 5,
                                      paddingTop: 5,
                                      color: "#00000099",
                                    }}
                                  >
                                    {component.answerList &&
                                    component.answerList[0] &&
                                    component.answerList[0].maxLength
                                      ? component.answerList[0].maxLength +
                                        " of " +
                                        component.answerList[0].maxLength +
                                        " Character(s) left"
                                      : ""}
                                  </Typography>
                                </>
                              )}
                            {component &&
                              (component.answerTypeId.name === "drop_down" ||
                                component.answerTypeId.name === "drop_down_state" ||
                                component.answerTypeId.name === "drop_down_country") && (
                                <ThemeProvider theme={formLabelsTheme}>
                                  <form noValidate autoComplete="off">
                                    <Autocomplete
                                      key={selectedVal}
                                      options={component.answerList.map(
                                        ({ label }) => label
                                      )}
                                      disableClearable
                                      fullWidth
                                      getOptionLabel={option => option}
                                      renderInput={params => (
                                        <TextField
                                          required={component.mandatory}
                                          fullWidth
                                          label={
                                            selectedVal === "Select"
                                              ? "Select"
                                              : selectedVal === "Use State"
                                              ? "Select State"
                                              : "Select Country"
                                          }
                                          margin="normal"
                                          name="selectOptions"
                                          id="selectOptions"
                                          variant="outlined"
                                          {...params}
                                        />
                                      )}
                                    />
                                  </form>
                                </ThemeProvider>
                              )}
                            {component &&
                              component.answerTypeId.name === "radio_button" && (
                                <>
                                  {component.mandatory && (
                                    <Box
                                      pb={0.25}
                                      style={{
                                        display: "flex",
                                        flexDirection: "row",
                                      }}
                                    >
                                      <Typography
                                        variant="h3"
                                        style={{
                                          fontSize: 14,
                                          display: "flex",
                                          alignItems: "center",
                                          paddingLeft: 5,
                                        }}
                                      >
                                        Required
                                      </Typography>
                                      <StyledTooltip title="required field">
                                        <Typography
                                          variant="h3"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            color: "#E53935",
                                            paddingLeft: 5,
                                            paddingRight: 5,
                                          }}
                                        >
                                          *
                                        </Typography>
                                      </StyledTooltip>
                                    </Box>
                                  )}
                                  <RadioGroup
                                    aria-labelledby="demo-radio-buttons-group-label"
                                    defaultValue="female"
                                    name="radio-buttons-group"
                                  >
                                    {component.answerList &&
                                      component.answerList
                                        .map(({ label }) => label)
                                        .map((option, index) => (
                                          <FormControlLabel
                                            value={option}
                                            control={<Radio />}
                                            label={option}
                                            className={classes.radioLabelStyle}
                                          />
                                        ))}
                                  </RadioGroup>
                                </>
                              )}

                            {component &&
                              component.answerTypeId.name === "checkbox_multiple" && (
                                <>
                                  {component.answerList.length > 0 &&
                                    component.mandatory && (
                                      <Box
                                        pb={0.25}
                                        style={{
                                          display: "flex",
                                          flexDirection: "row",
                                        }}
                                      >
                                        <Typography
                                          variant="h3"
                                          style={{
                                            display: "flex",
                                            alignItems: "center",
                                            paddingLeft: 5,
                                            paddingRight: 5,
                                            fontSize: 14,
                                          }}
                                        >
                                          <div>
                                            Required{" "}
                                            <span style={{ color: "#E53935" }}> *</span>
                                          </div>
                                        </Typography>
                                      </Box>
                                    )}
                                  <Box
                                    style={{
                                      // paddingTop: 5,
                                      display: "flex",
                                      flexDirection: "column",
                                      // justifyContent: "flex-start",
                                      // marginLeft: 30,
                                    }}
                                  >
                                    {component.answerList
                                      .map(({ label }) => label)
                                      .map((element, index) => (
                                        <FormControlLabel
                                          control={<Checkbox />}
                                          label={element}
                                        />
                                      ))}
                                  </Box>
                                </>
                              )}
                          </CardContent>
                        </Collapse>
                      </List>
                    </Box>
                  ))}
                </Card>
              </Grid>
              {alertMsg.msg && (
                <AlertDialog
                  title={alertMsg.title}
                  type={alertMsg.type}
                  contentMsg={alertMsg.msg}
                  closeDialog={() => setAlertMsg([])}
                  deleteAction={() => {
                    setAlertMsg([]);
                    removeComponent();
                  }}
                />
              )}
              {previewAlertMsg.msg && (
                <AlertDialog
                  title={previewAlertMsg.title}
                  contentMsg={previewAlertMsg.msg}
                  closeDialog={() => {
                    setPreviewAlertMsg([]);
                  }}
                />
              )}
              {openEditDialog &&
                currentEditComponent &&
                currentEditComponent.answerTypeId.name === "text" && (
                  <EditTextToFormDialog
                    closeDialog={() => setOpenEditDialog(false)}
                    infoIcon={currentEditComponent.tooltip !== ""}
                    manAnswer={currentEditComponent.mandatory}
                    queText={convertTxtToRichTxt(currentEditComponent.label)}
                    //queRaw={JSON.parse(currentEditComponent.label.replace(/'/g, '"'))}
                    //By sami for fixing bug_25Aug2025
                    queRaw={JSON.parse(currentEditComponent.label)}
                    capText={convertTxtToRichTxt(currentEditComponent.caption)}
                    //capRaw={JSON.parse(currentEditComponent.caption.replace(/'/g, '"'))}
                    //By sami for fixing bug_25Aug2025
                    capRaw={JSON.parse(currentEditComponent.caption)}
                    maxChar={currentEditComponent.answerList[0].maxLength}
                    infoTxt={currentEditComponent.tooltip}
                    handleDone={(
                      object,
                      addEditStatus,
                      infoIcon,
                      manAnswer,
                      queText,
                      queRaw,
                      capText,
                      capRaw,
                      maxChar,
                      infoTxt,
                      selectedVal,
                      selectedOpts,
                      mutiOptFields,
                      width,
                      height,
                      editMode
                    ) =>
                      handleDoneAddEditObjectToForm(
                        object,
                        addEditStatus,
                        infoIcon,
                        manAnswer,
                        queText,
                        queRaw,
                        capText,
                        capRaw,
                        maxChar,
                        infoTxt,
                        selectedVal,
                        selectedOpts,
                        mutiOptFields,
                        width,
                        height,
                        editMode
                      )
                    }
                  />
                )}
              {openEditDialog &&
                currentEditComponent &&
                currentEditComponent.answerTypeId.name === "textarea" && (
                  <EditTextAreaToFormDialog
                    closeDialog={() => setOpenEditDialog(false)}
                    infoIcon={currentEditComponent.tooltip !== ""}
                    manAnswer={currentEditComponent.mandatory}
                    queText={convertTxtToRichTxt(currentEditComponent.label)}
                    //queRaw={JSON.parse(currentEditComponent.label.replace(/'/g, '"'))}
                    //By sami for fixing bug_25Aug2025
                    queRaw={JSON.parse(currentEditComponent.label)}
                    capText={convertTxtToRichTxt(currentEditComponent.caption)}
                    //capRaw={JSON.parse(currentEditComponent.caption.replace(/'/g, '"'))}
                    //By sami for fixing bug_25Aug2025
                    capRaw={JSON.parse(currentEditComponent.caption)}
                    maxChar={currentEditComponent.answerList[0].maxLength}
                    infoTxt={currentEditComponent.tooltip}
                    width={
                      currentEditComponent.answerList[0].width
                        ? currentEditComponent.answerList[0].width
                        : 50
                    }
                    height={
                      currentEditComponent.answerList[0].height
                        ? currentEditComponent.answerList[0].height
                        : 3
                    }
                    handleDone={(
                      object,
                      addEditStatus,
                      infoIcon,
                      manAnswer,
                      queText,
                      queRaw,
                      capText,
                      capRaw,
                      maxChar,
                      infoTxt,
                      selectedVal,
                      selectedOpts,
                      mutiOptFields,
                      width,
                      height,
                      editMode
                    ) =>
                      handleDoneAddEditObjectToForm(
                        object,
                        addEditStatus,
                        infoIcon,
                        manAnswer,
                        queText,
                        queRaw,
                        capText,
                        capRaw,
                        maxChar,
                        infoTxt,
                        selectedVal,
                        selectedOpts,
                        mutiOptFields,
                        width,
                        height,
                        editMode
                      )
                    }
                  />
                )}
              {openEditDialog &&
                currentEditComponent &&
                currentEditComponent.answerTypeId.name === "content" && (
                  <EditContentToFormDialog
                    closeDialog={() => setOpenEditDialog(false)}
                    queText={convertTxtToRichTxt(currentEditComponent.label)}
                    //queRaw={JSON.parse(currentEditComponent.label.replace(/'/g, '"'))}
                    //By sami for fixing bug_25Aug2025
                    queRaw={JSON.parse(currentEditComponent.label)}
                    capText={convertTxtToRichTxt(currentEditComponent.caption)}
                    //capRaw={JSON.parse(currentEditComponent.caption.replace(/'/g, '"'))}
                    //By sami for fixing bug_25Aug2025
                    capRaw={JSON.parse(currentEditComponent.caption)}
                    handleDone={(
                      object,
                      addEditStatus,
                      infoIcon,
                      manAnswer,
                      queText,
                      queRaw,
                      capText,
                      capRaw,
                      maxChar,
                      infoTxt,
                      selectedVal,
                      selectedOpts,
                      mutiOptFields,
                      width,
                      height,
                      editMode
                    ) =>
                      handleDoneAddEditObjectToForm(
                        object,
                        addEditStatus,
                        infoIcon,
                        manAnswer,
                        queText,
                        queRaw,
                        capText,
                        capRaw,
                        maxChar,
                        infoTxt,
                        selectedVal,
                        selectedOpts,
                        mutiOptFields,
                        width,
                        height,
                        editMode
                      )
                    }
                  />
                )}
              {openEditDialog &&
                currentEditComponent &&
                (currentEditComponent.answerTypeId.name === "drop_down" ||
                  currentEditComponent.answerTypeId.name === "drop_down_state" ||
                  currentEditComponent.answerTypeId.name === "drop_down_country") && (
                  <EditDropDownToFormDialog
                    closeDialog={() => setOpenEditDialog(false)}
                    infoIcon={currentEditComponent.tooltip !== ""}
                    manAnswer={currentEditComponent.mandatory}
                    queText={convertTxtToRichTxt(currentEditComponent.label)}
                    //queRaw={JSON.parse(currentEditComponent.label.replace(/'/g, '"'))}
                    //By sami for fixing bug_25Aug2025
                    queRaw={JSON.parse(currentEditComponent.label)}
                    capText={convertTxtToRichTxt(currentEditComponent.caption)}
                    //capRaw={JSON.parse(currentEditComponent.caption.replace(/'/g, '"'))}
                    //By sami for fixing bug_25Aug2025
                    capRaw={JSON.parse(currentEditComponent.caption)}
                    maxChar={currentEditComponent.maxLength}
                    infoTxt={currentEditComponent.tooltip}
                    selectedVal={
                      currentEditComponent.answerTypeId.name === "drop_down_state"
                        ? "Use State"
                        : currentEditComponent.answerTypeId.name === "drop_down_country"
                        ? "Use Country"
                        : "Select"
                    }
                    selectedOpts={currentEditComponent.answerList.map(
                      ({ label }) => label
                    )}
                    handleDone={(
                      object,
                      addEditStatus,
                      infoIcon,
                      manAnswer,
                      queText,
                      queRaw,
                      capText,
                      capRaw,
                      maxChar,
                      infoTxt,
                      selectedVal,
                      selectedOpts,
                      mutiOptFields,
                      width,
                      height,
                      editMode
                    ) =>
                      handleDoneAddEditObjectToForm(
                        object,
                        addEditStatus,
                        infoIcon,
                        manAnswer,
                        queText,
                        queRaw,
                        capText,
                        capRaw,
                        maxChar,
                        infoTxt,
                        selectedVal,
                        selectedOpts,
                        mutiOptFields,
                        width,
                        height,
                        editMode
                      )
                    }
                  />
                )}
              {openEditDialog &&
                currentEditComponent &&
                currentEditComponent.answerTypeId.name === "radio_button" && (
                  <EditRadioButtonToFormDialog
                    closeDialog={() => setOpenEditDialog(false)}
                    infoIcon={currentEditComponent.tooltip !== ""}
                    manAnswer={currentEditComponent.mandatory}
                    queText={convertTxtToRichTxt(currentEditComponent.label)}
                    //queRaw={JSON.parse(currentEditComponent.label.replace(/'/g, '"'))}
                    //By sami for fixing bug_25Aug2025
                    queRaw={JSON.parse(currentEditComponent.label)}
                    capText={convertTxtToRichTxt(currentEditComponent.caption)}
                    //capRaw={JSON.parse(currentEditComponent.caption.replace(/'/g, '"'))}
                    //By sami for fixing bug_25Aug2025
                    capRaw={JSON.parse(currentEditComponent.caption)}
                    maxChar={currentEditComponent.maxLength}
                    infoTxt={currentEditComponent.tooltip}
                    selectedVal={selectedVal}
                    selectedOpts={currentEditComponent.answerList.map(
                      ({ label }) => label
                    )}
                    handleDone={(
                      object,
                      addEditStatus,
                      infoIcon,
                      manAnswer,
                      queText,
                      queRaw,
                      capText,
                      capRaw,
                      maxChar,
                      infoTxt,
                      selectedVal,
                      selectedOpts,
                      mutiOptFields,
                      width,
                      height,
                      editMode
                    ) =>
                      handleDoneAddEditObjectToForm(
                        object,
                        addEditStatus,
                        infoIcon,
                        manAnswer,
                        queText,
                        queRaw,
                        capText,
                        capRaw,
                        maxChar,
                        infoTxt,
                        selectedVal,
                        selectedOpts,
                        mutiOptFields,
                        width,
                        height,
                        editMode
                      )
                    }
                  />
                )}

              {openEditDialog &&
                currentEditComponent &&
                (currentEditComponent.answerTypeId.name === "checkbox_single" ||
                  currentEditComponent.answerTypeId.name === "checkbox_multiple") && (
                  <EditCheckboxToFormDialog
                    closeDialog={() => setOpenEditDialog(false)}
                    infoIcon={currentEditComponent.tooltip !== ""}
                    manAnswer={currentEditComponent.mandatory}
                    queText={convertTxtToRichTxt(currentEditComponent.label)}
                    //queRaw={JSON.parse(currentEditComponent.label.replace(/'/g, '"'))}
                    //By sami for fixing bug_25Aug2025
                    queRaw={JSON.parse(currentEditComponent.label)}
                    capText={convertTxtToRichTxt(currentEditComponent.caption)}
                    //capRaw={JSON.parse(currentEditComponent.caption.replace(/'/g, '"'))}
                    //By sami for fixing bug_25Aug2025
                    capRaw={JSON.parse(currentEditComponent.caption)}
                    maxChar={currentEditComponent.maxLength}
                    infoTxt={currentEditComponent.tooltip}
                    selectedVal={selectedVal}
                    selectedOpts={selectedOpts}
                    mutiOptFields={
                      currentEditComponent.answerTypeId.name === "checkbox_single"
                        ? []
                        : currentEditComponent.answerList.map(({ label }) => label)
                    }
                    handleDone={(
                      object,
                      addEditStatus,
                      infoIcon,
                      manAnswer,
                      queText,
                      queRaw,
                      capText,
                      capRaw,
                      maxChar,
                      infoTxt,
                      selectedVal,
                      selectedOpts,
                      mutiOptFields,
                      width,
                      height,
                      editMode
                    ) =>
                      handleDoneAddEditObjectToForm(
                        object,
                        addEditStatus,
                        infoIcon,
                        manAnswer,
                        queText,
                        queRaw,
                        capText,
                        capRaw,
                        maxChar,
                        infoTxt,
                        selectedVal,
                        selectedOpts,
                        mutiOptFields,
                        width,
                        height,
                        editMode
                      )
                    }
                  />
                )}
            </Grid>
          </DndProvider>
        </div>
      </div>
    );

    else
      return (
        <div className={classes.root}>
          <div className={classes.container}>
            <AlertDialog
                title="No Permission"
                contentMsg='You do not have permission to access this page.
                            Click the "Done" button and navigate the system through the designated menu options on the sidebar menu.'
                closeDialog={() => {
                  navigate(`${project_url}/tenant/dashboard`);
                }}
              />

          </div>
        </div>
      );

  else return;
}

export default FormDialog;
